// propertyAPI.js

import axiosInstance from "../BaseURL/axiosInstance";
import API_BASE_URL from "../BaseURL/baseURL";

export const fetchDistrictData = async () => {
  const response = await fetch(
    `${API_BASE_URL}/PropertyRegistration/getDistrict`
  );
  if (!response.ok) throw new Error("Failed to fetch data");
  return await response.json();
};

export const fetchSROData = async (districtId) => {
  const response = await fetch(
    `${API_BASE_URL}/PropertyRegistration/getSRO?districtCode=${districtId}`
  );
  if (!response.ok) throw new Error("Failed to fetch data");
  return await response.json();
};

export const fetchDeedData = async () => {
  const response = await fetch(`${API_BASE_URL}/PropertyRegistration/getDeed`);
  if (!response.ok) throw new Error("Failed to fetch data");
  return await response.json();
};

export const fetchSubdeedData = async (deedId) => {
  const response = await fetch(
    `${API_BASE_URL}/PropertyRegistration/getSubdeed?deedCode=${deedId}`
  );
  if (!response.ok) throw new Error("Failed to fetch data");
  return await response.json();
};

export const fetchBookNo = async (deedId) => {
  const response = await fetch(
    `${API_BASE_URL}/PropertyRegistration/Get_bookno?deedCode=${deedId}`
  );
  if (!response.ok) throw new Error("Failed to fetch data");
  return await response.json();
};

export const fetchFloorNoData = async () => {
  const response = await fetch(
    `${API_BASE_URL}/PropertyRegistration/Get_Floor`
  );
  if (!response.ok) throw new Error("Failed to fetch data");
  return await response.json();
};

export const fetchUnitData = async () => {
  const response = await fetch(`${API_BASE_URL}/PropertyRegistration/Get_Unit`);
  if (!response.ok) throw new Error("Failed to fetch data");
  return await response.json();
};

export const fetchRiderData = async () => {
  const response = await fetch(
    `${API_BASE_URL}/PropertyRegistration/Get_Rider`
  );
  if (!response.ok) throw new Error("Failed to fetch data");
  return await response.json();
};

export const fetchLandRateCalculation = async ({
  dcode,
  srocode,
  ratelist_year,
}) => {
  const response = await fetch(
    `${API_BASE_URL}/PropertyRegistration/getLandRateCalculation?dcode=${dcode}&srocode=${srocode}&ratelist_year=${encodeURIComponent(
      ratelist_year
    )}`,
    {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    }
  );
  if (!response.ok)
    throw new Error("Failed to fetch land rate calculation data");
  return await response.json();
};

export const fetchMutationDetail = async () => {
  const response = await fetch(
    `${API_BASE_URL}/PropertyRegistration/getMutationDetail`
  );
  if (!response.ok) throw new Error("Failed to fetch data");
  return await response.json();
};

export const fetchMutationOfficeDetail = async ({
  mutationDepartment,
  dcode,
  srocode,
}) => {
  const response = await fetch(
    `${API_BASE_URL}/PropertyRegistration/getOfficeDetail?TYPE_CODE=${mutationDepartment}&dcode=${dcode}&srocode=${srocode}`,
    {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    }
  );
  if (!response.ok)
    throw new Error("Failed to fetch land rate calculation data");
  return await response.json();
};

export const fetchRateListDetails = async ({
  dcode,
  scocode,
  allcode,
  rateyear,
}) => {
  const response = await fetch(
    `${API_BASE_URL}/PropertyRegistration/Get_ratelist_details`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        dcode,
        scocode,
        allcode,
        rateyear,
      }),
    }
  );
  if (!response.ok) {
    throw new Error("Failed to fetch rate list details");
  }
  return await response.json();
};

// export const insertPropertyData = async (propertyData) => {
//   const response = await fetch(
//     `${API_BASE_URL}/CompleteProperty/InsertPropertyData`,
//     {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(propertyData),
//     }
//   );
//   if (!response.ok) {
//     throw new Error("Failed to insert property data");
//   }
//   return await response.json();
// };

export const insertPropertyData = async (propertyData) => {
  try {
    const response = await axiosInstance.post(
      "/CompleteProperty/InsertPropertyData",
      propertyData
    );
    return response.data;
  } catch (error) {
    console.error("Insert Property Error:", error);
    throw new Error("Failed to insert property data");
  }
};

// export const updatePropertyData = async (propertyData) => {
//   const response = await fetch(
//     `${API_BASE_URL}/CompleteProperty/UpdatePropertyData`,
//     {
//       method: "PUT",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(propertyData),
//     }
//   );
//   if (!response.ok) {
//     throw new Error("Failed to insert property data");
//   }
//   return await response.json();
// };

// export const insertAreaMajData = async (areaMajData) => {
//   const response = await fetch(
//     `${API_BASE_URL}/PropertyRegistration/insert_getAreaMAj`,
//     {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(areaMajData),
//     }
//   );
//   if (!response.ok) {
//     throw new Error("Failed to insert property data");
//   }
//   return await response.text();
// };

// export const updateAreaMajData = async (areaMajData) => {
//   const response = await fetch(
//     `${API_BASE_URL}/PropertyRegistration/Update_getAreaMAj`,
//     {
//       method: "PUT",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(areaMajData),
//     }
//   );
//   debugger;
//   if (!response.ok) {
//     throw new Error("Failed to update property data");
//   }
//   return await response.text();
// };

export const updatePropertyData = async (propertyData) => {
  try {
    const response = await axiosInstance.put(
      "/CompleteProperty/UpdatePropertyData",
      propertyData
    );
    return response.data;
  } catch (error) {
    console.error("Update Property Error:", error);
    throw new Error("Failed to update property data");
  }
};

export const insertAreaMajData = async (areaMajData) => {
  try {
    const response = await axiosInstance.post(
      "/PropertyRegistration/insert_getAreaMAj",
      areaMajData
    );
    return response.data;
  } catch (error) {
    console.error("Insert AreaMaj Error:", error);
    throw new Error("Failed to insert AreaMaj data");
  }
};

export const updateAreaMajData = async (areaMajData) => {
  try {
    const response = await axiosInstance.put(
      "/PropertyRegistration/Update_getAreaMAj",
      areaMajData
    );
    return response.data;
  } catch (error) {
    console.error("Update AreaMaj Error:", error);
    throw new Error("Failed to update AreaMaj data");
  }
};

export const fetchPaymentMode = async () => {
  console.log("fetchPaymentMode API function called");
  const response = await fetch(
    `${API_BASE_URL}/PropertyEvaluation/Mode_Payment?key=VIR2024@@`
  );
  if (!response.ok) throw new Error("Failed to fetch data");
  const data = await response.json();
  console.log("fetchPaymentMode API response:", data);
  return data;
};

export const fetchRegistrationFee = async ({ deedcode, subDeedCode }) => {
  const response = await fetch(
    `${API_BASE_URL}/PropertyEvaluation/get_registration_fee?deedcode=${deedcode}&subdeedcode=${subDeedCode}`,
    {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    }
  );
  if (!response.ok) throw new Error("Failed to fetch Registration fee");
  return await response.json();
};

export const fetchStampDuty = async ({ deedcode, subDeedCode }) => {
  const response = await fetch(
    `${API_BASE_URL}/PropertyEvaluation/get_stampduty?deedcode=${deedcode}&subdeedcode=${subDeedCode}`,
    {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    }
  );
  if (!response.ok) throw new Error("Failed to fetch Stamp duty");
  return await response.json();
};

export const insertStampRegFeeData = async (regFeeData) => {
  const response = await fetch(
    `${API_BASE_URL}/PropertyEvaluation/Calculate_stamp_rfee`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(regFeeData),
    }
  );
  if (!response.ok) {
    throw new Error("Failed to insert reg fee data");
  }
  return await response.json();
};

// export const insertPropertyEvalData = async (propertyEvalData) => {
//   ////debugger;
//   const response = await fetch(
//     `${API_BASE_URL}/PropertyEvaluation/InsertPropData_step2`,
//     {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(propertyEvalData),
//     }
//   );
//   if (!response.ok) {
//     throw new Error("Failed to insert property data");
//   }
//   return await response.json();
// };

export const insertPropertyEvalData = async (propertyEvalData) => {
  try {
    const response = await axiosInstance.post(
      "/PropertyEvaluation/InsertPropData_step2",
      propertyEvalData
    );
    return response.data;
  } catch (error) {
    console.error("Insert Property Evaluation Error:", error);
    throw new Error("Failed to insert property evaluation data");
  }
};

export const fetchFloorMassResi = async ({ dcode, srocode }) => {
  const response = await fetch(
    `${API_BASE_URL}/CompleteProperty/Get_FLOOR_MAS_resi?dcode=${dcode}&srocode=${srocode}&mode=resi`,
    {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    }
  );
  if (!response.ok) throw new Error("Failed to fetch Floor Mass");
  return await response.json();
};

export const fetchFloorMassComm = async ({ dcode, srocode }) => {
  const response = await fetch(
    `${API_BASE_URL}/CompleteProperty/Get_FLOOR_MAS_comm?dcode=${dcode}&srocode=${srocode}&mode=comm`,
    {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    }
  );
  if (!response.ok) throw new Error("Failed to fetch floor Mass Comm");
  return await response.json();
};

export const fetchPropertyAreaResi = async ({ dcode, srocode }) => {
  const response = await fetch(
    `${API_BASE_URL}/CompleteProperty/Get_Struct_type?dcode=${dcode}&srocode=${srocode}`,
    {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    }
  );
  if (!response.ok) throw new Error("Failed to fetch Property Area");
  return await response.json();
};

// export const fetchConstructionTypeAndYear = async ({
//   dcode,
//   srocode,
//   structclass_code,
// }) => {
//   const response = await fetch(
//     "https://localhost:7122/api/CompleteProperty/InsertPropertyData",
//     {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(propertyData),
//     }
//   );
//   if (!response.ok) {
//     throw new Error("Failed to insert property data");
//   }
//   return await response.json();
// };

// export const fetchConstructionTypeAndYear = async ({
//   dcode,
//   srocode,
//   structclass_code,
// }) => {
//   const requestBody = {
//     dcode,
//     srocode,
//     structclass_code,
//   };

//   try {
//     const response = await fetch(
//       "https://localhost:7122/api/CompleteProperty/Resi_property_area",
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(requestBody),
//       }
//     );

//     if (!response.ok) {
//       throw new Error("Failed to fetch construction type and year data");
//     }

//     return await response.json(); // Return parsed JSON response
//   } catch (error) {
//     throw new Error("Failed to fetch construction type and year data");
//   }
// };

export const fetchConstructionTypeAndYear = async ({
  dcode,
  srocode,
  structclass_code,
}) => {
  const response = await fetch(
    `${API_BASE_URL}/CompleteProperty/Resi_property_area?dcode=${dcode}&srocode=${srocode}&Structclass_code=${structclass_code}`,
    {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    }
  );
  if (!response.ok) throw new Error("Failed to fetch Property Area");
  return await response.json();
};
